import { clsx } from 'clsx';
import Skeleton from 'react-loading-skeleton';

import { CircleIcon } from '@/components/icons/category';
import { CategoriesWithStatuses } from '@/types';

import cn from './styles.module.sass';

interface ICategoriesProps {
    categories: CategoriesWithStatuses;
    onClick?: (id: number) => void;
    isLoading?: boolean;
}

export const Categories = ({ categories, onClick, isLoading }: ICategoriesProps) => {
    return (
        <div className={cn.container}>
            {isLoading ? (
                <Skeleton
                    height={30}
                    width={104}
                    count={3}
                    containerClassName={cn.categoriesSkeletonContainer}
                />
            ) : (
                categories.map(category => (
                    <div
                        key={category.id}
                        onClick={onClick?.bind(null, category.id)}
                        className={clsx(cn.categoryItem, category.active && cn.active)}
                    >
                        <span style={{ color: category.color }} className={clsx(cn.icon)}>
                            {CircleIcon}
                        </span>
                        <span className={cn.categoryName}> {category.name}</span>
                    </div>
                ))
            )}
        </div>
    );
};
